// imported json
import annexAlarmGroup from '@/pages/uicomponents/components/annex-alarm';
import { eventComponentsGroup } from '@/pages/uicomponents/components/event/group';

export const componentsData = [annexAlarmGroup, eventComponentsGroup];
